export * from './urls';
export * from './keys';

export const PAGE_SIZE_TEAM_MEMBERS = 20;

export const UNKNOWN_DEPARTMENT_ID = 'unknown';
